export const categoryData = [
    {
        name: 'compressors',
        alt: 'compressors',
        id: '8',
    },
    {
        name: 'compressed.air.treatment',
        alt: 'compresses air treatment',
        id: '243',
    },
    {
        name: 'special.gases',
        alt: 'special gases',
        id: '539',
    },
    {
        name: 'controls',
        alt: 'controls',
        id: '253',
    },
];
